import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RecommendationHistory = ({ studentId }) => {
  const mockRecommendations = [
  {
    id: 1,
    title: 'Sciences de l\'Ingénieur',
    category: 'Sciences & Technologies',
    matchScore: 92,
    icon: 'Cpu',
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_136076b03-1767113315595.png',
    imageAlt: 'Modern engineering workspace with computer screens displaying technical blueprints and circuit diagrams',
    dateAdded: '2026-02-08',
    viewed: true,
    tags: ['Mathématiques', 'Physique']
  },
  {
    id: 2,
    title: 'Économie et Gestion',
    category: 'Sciences Économiques',
    matchScore: 88,
    icon: 'TrendingUp',
    image: "https://images.unsplash.com/photo-1707762890671-52ef6d6f51e7",
    imageAlt: 'Business professionals analyzing financial charts and graphs on laptop screen',
    dateAdded: '2026-02-05',
    viewed: true,
    tags: ['Finance', 'Management']
  },
  {
    id: 3,
    title: 'Sciences de la Santé',
    category: 'Médecine & Santé',
    matchScore: 85,
    icon: 'Heart',
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_121a31716-1766513916498.png',
    imageAlt: 'Medical professional in white coat examining patient charts in modern hospital',
    dateAdded: '2026-02-03',
    viewed: false,
    tags: ['Médecine', 'Biologie']
  }];


  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Icon name="Lightbulb" size={24} className="text-primary" />
          <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
            Recommandations de Filières
          </h2>
        </div>
        <span className="text-sm text-muted-foreground">
          {mockRecommendations?.length} filières
        </span>
      </div>

      <div className="space-y-4">
        {mockRecommendations?.map((rec) =>
        <div
          key={rec?.id}
          className="border border-border rounded-lg overflow-hidden hover:shadow-md transition-all duration-250">
          
            <div className="flex flex-col sm:flex-row">
              <div className="relative w-full sm:w-32 h-32 sm:h-auto flex-shrink-0">
                <Image
                src={rec?.image}
                alt={rec?.imageAlt}
                className="w-full h-full object-cover" />
              
                <div className="absolute top-2 right-2">
                  <div className="bg-primary text-primary-foreground px-2 py-1 rounded-full text-xs font-medium">
                    {rec?.matchScore}%
                  </div>
                </div>
              </div>
              <div className="flex-1 p-4">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-start gap-2 flex-1">
                    <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon name={rec?.icon} size={16} className="text-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">
                        {rec?.title}
                      </h3>
                      <p className="text-xs text-muted-foreground">{rec?.category}</p>
                    </div>
                  </div>
                  {rec?.viewed ?
                <div className="flex items-center gap-1 text-success text-xs flex-shrink-0 ml-2">
                      <Icon name="Eye" size={14} />
                      <span>Vue</span>
                    </div> :

                <div className="flex items-center gap-1 text-warning text-xs flex-shrink-0 ml-2">
                      <Icon name="EyeOff" size={14} />
                      <span>Non vue</span>
                    </div>
                }
                </div>
                <div className="flex flex-wrap gap-2 mb-2">
                  {rec?.tags?.map((tag, index) =>
                <span
                  key={index}
                  className="px-2 py-1 bg-muted text-muted-foreground rounded-md text-xs">
                  
                      {tag}
                    </span>
                )}
                </div>
                <p className="text-xs text-muted-foreground">
                  Ajoutée le {new Date(rec?.dateAdded)?.toLocaleDateString('fr-FR')}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default RecommendationHistory;